import * as R from 'ramda'

export const financialTypes = {
  COMPANY_OR_HOUSE: '在美房產或公司證明',
  DEPOSIT_50M: '超6個月的50萬美元存款證明',
  DEPOSIT_500M: '全球超500萬美元資產證明'
}

export const financialTypeKeys = R.keys(financialTypes)
export const financialTypeValues = R.values(financialTypes)
